/*
 * @Author: 左侧菜单重构
 * @Date:   2017-09-11 16:07:27
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-09-12 17:22:06
 */

'use strict';
angular.module('createLeftModule', [])
    .directive('createLeft', ["$state", "$location", function($state, $location) {
        // Runs during compile
        return {
            scope: {
                data: '=',
                callback: '&',
                selectedNode: '='
            },
            restrict: 'AE',
            templateUrl: './resourceCenter/directive/createLeft/createLeft.html',
            replace: true,
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        isChnlClose: true,
                        isSelectedParent: "",
                        isSlected: "",
                    }
                }
                /**
                 * [initStatus description] 展开和选中样式
                 * @return {[type]} [description]
                 */
                $scope.onSelection = function(value) {
                    $scope.status.isSelectedParent = $scope.status.isSelectedParent == value.ID ? "" : value.ID;
                };
                $scope.showSelected = function(value) {
                    $scope.selectedNode = value;
                    $scope.callback();
                }
                /**
                 * [showSelected description] test选中节点
                 * @param {[object]} [node] [description] 所选节点
                 * @param {[object]} [selected] [description] 选中节点
                 * @param {[object]} [parentNode] [description] 父节点
                 * @return {[type]} [description]
                 */
                $scope.showSelected = function(node, parentNode) {
                    event.stopPropagation();
                    var nodeId, url;

                    if (node.ID) {
                        $scope.status.isSlected = node.ID;
                        nodeId = node.ID;
                    } else {
                        $scope.status.isSlected = node.id;
                        nodeId = node.id;
                    }

                    if (parentNode.ID == "55") {
                        url = "front.resourcectrl.share.robotdraft";
                    } else if (nodeId == 31) {
                        url = "front.resourcectrl.share.email";
                    } else {
                        if ($state.current.name.indexOf("email") > -1) {
                            url = $state.current.name.replace(".email", "") + ".resource";
                        } else {
                            //url = $state.current.name;
                            url = "front.resourcectrl.share.resource";
                        }
                    }
                    var isUgc = "0";
                    if (angular.isDefined(parentNode.ISUGC) && node.ISUGC == "1") {
                        isUgc = "1";
                    }
                    // $state.go(url, {
                    //     modalid: "37",
                    //     nodeid: nodeId,
                    //     nodename: node.dictName || node.CATEGORYNAME,
                    //     change: Math.random(0, 1) * 100,
                    //     isugc: isUgc == "1" ? "1" : "0"
                    // }, { reload: url });
                };
                $scope.setTabSelected = function(param) {
                    var path = $location.path().split('/');
                    $scope.status.isChnlClose = true;
                    if (path[2] == param) {
                        return false;
                    }
                    $scope.status.isChnlStatus = param;
                    var willgo = 'front.editctr.' + param;
                    if ($state.current.name.indexOf(willgo) >= 0) {
                        $state.go($state.current.name, $stateParams, { reload: $state.current.name });
                    } else {
                        $state.go(willgo);
                    }
                };
                /**
                 * [showSelected description] 选中节点
                 * @param {[object]} [node] [description] 所选节点
                 * @return {[type]} [description]
                 */
                $scope.childrenList = function(value){
                    if(value.CHILDLIST){
                        return alert('childlist');
                    }else if(value.CHILDREN){
                        alert('child');
                    }
                }

            }
        };
    }]);
